import { render, staticRenderFns } from "./Glosswindow.vue?vue&type=template&id=4641ac76"
import script from "./Glosswindow.vue?vue&type=script&lang=js"
export * from "./Glosswindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports